import React, { Component } from 'react';
import withRouter from "./components/withRouter"
import { Container, Row, Col, Button, Card } from 'react-bootstrap';

import requester from "../library/Requester"; 
import * as util from '../library/utilitys';
import * as Actions from './actions/ActionCenter';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import styles from '../styles/frontend/HomePage.css';

import CommonImageFrontend from './components/CommonImageFrontend';

// คอมเมนต์ไว้แทนการลบ: ไม่มี <Calendar /> ถูก render ใน component นี้ (ไม่ได้ใช้งานจริง ณ ตอนนี้)
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import moment from 'moment';
// import 'moment/locale/th';
// moment.locale('th');

const youtubeUrl1 = process.env.REACT_APP_YOUTUBE_1_URL;
const youtubeUrl2 = process.env.REACT_APP_YOUTUBE_2_URL;
const youtubeUrl3 = process.env.REACT_APP_YOUTUBE_3_URL;

export const weekDays = ['จันทร์', 'อังคาร', 'พุทธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์', 'อาทิตย์'];

export const calendarDays = [
    { day: '28', isOtherMonth: true },
    { day: '29', isOtherMonth: true },
    { day: '30', isOtherMonth: true },
    { day: '1', hasEvent: true },
    { day: '2', hasEvent: true },
    { day: '3', hasEvent: true },
    { day: '4', hasEvent: true },
    { day: '5' },
    { day: '6' },
    { day: '7' },
    { day: '8' },
    { day: '9' },
    { day: '10' },
    { day: '11' },
    { day: '12' },
    { day: '13' },
    { day: '14', hasEvent: true },
    { day: '15', hasEvent: true },
    { day: '16', hasEvent: true },
    { day: '17' },
    { day: '18' },
    { day: '19' },
    { day: '20' },
    { day: '21', hasEvent: true },
    { day: '22', hasEvent: true },
    { day: '23', hasEvent: true },
    { day: '24', hasEvent: true },
    { day: '25' },
    { day: '26' },
    { day: '27', hasEvent: true },
    { day: '28', hasEvent: true },
    { day: '29' },
    { day: '30' },
    { day: '31' },
    { day: '1', isOtherMonth: true }
];

const heroImagesTitle = 'EEC มีงานทำ'
const heroImagesSubTitle = 'ศูนย์กลางข้อมูล การพัฒนากำลังคนเพื่อรองรับการลงทุนของอุตสาหกรรมเป้าหมายในเขตพัฒนาพิเศษภาคตะวันออก'

const heroImages = [
  {
    src: '/images/open1_0.jpg',
    alt: 'EEC ท่าเรืออุตสาหกรรม',
    title: heroImagesTitle,
    subtitle: heroImagesSubTitle
  },
  {
    src: '/images/open2_0.jpg',
    alt: 'EEC เมืองอัจฉริยะ',
    title: heroImagesTitle,
    subtitle: heroImagesSubTitle
  },
  {
    src: '/images/open3_0.jpg',
    alt: 'EEC วิทยาศาสตร์การแพทย์',
    title: heroImagesTitle,
    subtitle: heroImagesSubTitle
  }
];

const VIEW = `frontend_publicize_data`; // คอมเมนต์ไว้แทนการลบ: ไม่ถูกใช้งาน (URL ด้านล่างคือตัวที่ใช้จริง) - เก็บไว้เผื่ออ้างอิง
const URL = `public/view/frontent/tops-info`;
const ATTACH_FILE_CONTENT_URL = `public/view/attach_files/files`;
// public/view/attach_files/files/75AC1F1B-B455-F011-943C-D9050A343A2B

const demandClusters = '/images/demand_clusters_tranf-01.png';

const eecModelPoster = '/images/eec_model_tramf-01.png'; // คอมเมนต์ไว้แทนการลบ: ไม่ถูกใช้งานใน render ปัจจุบัน

const overallPoster = '/images/poster_overall.png';
class HomePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bannerIndex: 0,
            networkIndex: 0, 

            newsGroups: [],
            activeGroupIndex: 0,
            
            DataTable1: [],
            DataTable3: [],
            // DataTable3: [], // เดิมประกาศซ้ำ (bug: key ซ้ำ ตัวหลังทับตัวแรก) คอมเมนต์ไว้แทนการลบ
            DataTable4: [
                { id: '1', title: 'ความต้องการกำลังคน', key: 'mAmount', value: 0, unit: 'ตำแหน่ง', backgroundImage: '/images/img__0x0.png' },
                { id: '2', title: 'EEC model type A', key: 'taAmount', value: 0, unit: 'คน', backgroundImage: '/images/img_1.png' },
                { id: '3', title: 'EEC model type B', key: 'tbAmount', value: 0, unit: 'คน', backgroundImage: '/images/img_2.png' },
                { id: '4', title: 'EEC model type C', key: 'tcAmount', value: 0, unit: 'คน', backgroundImage: '/images/img_4.png' },
                { id: '5', title: 'หลักสูตร', key: 'course', value: 0, unit: 'หลักสูตร', backgroundImage: '/images/img_5.png' },
                { id: '6', title: 'ศูนย์เครือข่าย EEC Nets', key: 'eeAmount', value: 0, unit: 'แห่ง', backgroundImage: '/images/img_6.png' },
                { id: '7', title: 'ประชาสัมพันธ์ทั่วไป', key: 'nAmount', value: 0, unit: 'รายการ', backgroundImage: '/images/img_7.png' },
                { id: '8', title: 'ประชาสัมพันธ์การฝึกอบรม', key: 'tAmount', value: 0, unit: 'รายการ', backgroundImage: '/images/img_8.png' },
                { id: '9', title: 'ประชาสัมพันธ์ตำแหน่งงาน', key: 'pAmount', value: 0, unit: 'ตำแหน่ง', backgroundImage: '/images/img_9.png' }
            ],
            DataTable5: [],
            DatatableImage1: {},
            DatatableImage5: {},
            // คอมเมนต์ไว้แทนการลบ: ผูกกับ Calendar ที่ไม่ได้ render ในหน้านี้ (ไม่ได้ใช้งาน)
            // selectedDate: new Date(),
            // selectedMonth: this.getMonthName(new Date()),
            isMobile: window.innerWidth < 768,
        };
    }
    // คอมเมนต์ไว้แทนการลบ: ใช้คู่กับ selectedMonth ด้านบนที่ปิดไว้ (ไม่ได้ใช้งานเพราะไม่มี Calendar render)
    // getMonthName(date) {
    //     return date.toLocaleString('th-TH', { month: 'long', year: 'numeric' });
    // }

    async componentDidMount() {
        await this.loadDataToState();
        this.startAutoSlide();

        window.addEventListener('resize', this.handleResize);

        if (window.innerWidth < 768) {
            this.enableSwipeGesture();
            this.enableNewsSwipeGesture();
        }
    }

    componentWillUnmount() {
        clearInterval(this.heroInterval);      
        window.removeEventListener('resize', this.handleResize);
        if (this.cleanupSwipe) this.cleanupSwipe();
        if (this.cleanupNewsSwipe) this.cleanupNewsSwipe();
    }

    startAutoSlide = () => {
        if (this.heroInterval) clearInterval(this.heroInterval); // ป้องกันซ้ำ
        this.heroInterval = setInterval(() => {
            this.setState(
                (prevState) => ({
                bannerIndex: (prevState.bannerIndex + 1) % heroImages.length,
                }),
                () => {
                // console.log("Updated bannerIndex:", this.state.bannerIndex);
                }
            );
        }, 5000);
    };

    handlePrevBanner = () => {
        clearInterval(this.heroInterval);
        this.setState(
            (prevState) => ({
                bannerIndex: (prevState.bannerIndex - 1 + heroImages.length) % heroImages.length,
            }),
            () => {
                this.startAutoSlide();
            }
        );
    };

    handleNextBanner = () => {
        clearInterval(this.heroInterval);
        this.setState(
        (prevState) => ({
            bannerIndex: (prevState.bannerIndex + 1) % heroImages.length,
        }),
        () => {
            this.startAutoSlide();
        }
        );
    };

    handleResize = () => {
        const isMobile = window.innerWidth < 768;
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
            if (isMobile) this.enableSwipeGesture();
            else if (this.cleanupSwipe) this.cleanupSwipe();
        }
    };

    enableSwipeGesture = () => {
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;

        const handleTouchStart = (e) => (touchStartX = e.touches[0].clientX);
        const handleTouchEnd = (e) => {
        touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (diff > swipeThreshold) this.handlePrevBanner();
        else if (diff < -swipeThreshold) this.handleNextBanner();
        };

        this.bannerContainer = document.getElementById("heroBannerContainer");
        if (this.bannerContainer) {
            this.bannerContainer.addEventListener("touchstart", handleTouchStart);
            this.bannerContainer.addEventListener("touchend", handleTouchEnd);
        }

        this.cleanupSwipe = () => {
            if (this.bannerContainer) {
                this.bannerContainer.removeEventListener("touchstart", handleTouchStart);
                this.bannerContainer.removeEventListener("touchend", handleTouchEnd);
            }
        };
    };

    enableNewsSwipeGesture = () => {
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;
    
        const handleTouchStart = (e) => (touchStartX = e.touches[0].clientX);
        const handleTouchEnd = (e) => {
            touchEndX = e.changedTouches[0].clientX;
            const diff = touchStartX - touchEndX;
        
            if (diff > swipeThreshold) {
                this.setState((prev) => ({
                activeGroupIndex:
                    (prev.activeGroupIndex - 1 + prev.newsGroups.length) %
                    prev.newsGroups.length,
                }));
            } else if (diff < -swipeThreshold) {
                this.setState((prev) => ({
                activeGroupIndex:
                    (prev.activeGroupIndex + 1) % prev.newsGroups.length,
                }));
            }
        };
    
        this.newsContainer = document.getElementById("newsSectionContainer");
        if (this.newsContainer) {
            this.newsContainer.addEventListener("touchstart", handleTouchStart);
            this.newsContainer.addEventListener("touchend", handleTouchEnd);
        }
    
        this.cleanupNewsSwipe = () => {
            if (this.newsContainer) {
                this.newsContainer.removeEventListener("touchstart", handleTouchStart);
                this.newsContainer.removeEventListener("touchend", handleTouchEnd);
            }
        };
    };

  loadDataToState = async () => {
      // คอมเมนต์ไว้แทนการลบ: คำนวณไว้แต่ไม่เคยถูกส่งไป API (ดู comment "cancel search by years" ด้านล่าง)
      // const currentThaiYear = new Date().getFullYear() + 543;

      await this.putDataToState("DataTable1", "frontend_publicize_data", true, "DatatableImage1", { pageSize: 100 }, (data) => {
      const grouped = {};
      data.forEach(item => {
        if (!grouped[item.news_type]) grouped[item.news_type] = [];
        grouped[item.news_type].push(item);
      });

      // ใหม่: newsGroups = [{ groupName: 'ชื่อ', items: [] }]
      const limitedGroups = Object.entries(grouped).map(([key, items]) => ({
        groupName: key,
        items: items.slice(0, 4)
      }));

      this.setState({ newsGroups: limitedGroups }, () => {
        if (this.state.isMobile) {
          if (this.cleanupNewsSwipe) this.cleanupNewsSwipe();
          this.enableNewsSwipeGesture();
        }
      });
    });
    
    await this.putDataToState("DataTable3", "frontend_training_course", false, "", { pageSize: 10 });
    await this.putDataToState("DataTableTemp3", "frontend_positions_demand", false, "", { pageSize: 1 }, (data) => { //years: currentThaiYear, cancel search by years / need summary for front end
        if (data?.length) {
            const row = data[0];
            const updated = this.state.DataTable4.map(stat => ({
            ...stat,
            value: Number(row[stat.key]) || 0
            }));
            this.setState({ DataTable4: updated });
        }
    });

    await this.putDataToState("DataTable5", "frontend_eec_net", true, "DatatableImage5", { pageSize: 100 });
  }

  putDataToState = async (stateKey, path, loadImage = false, imageStateKey = "", body = {}, onAfterSetState = null) => {
  try {
    const response = await requester.post(`${URL}/${path}`, body);
    const data = response.data?.data?.data || response.data?.data || [];

    this.setState({ [stateKey]: data }, async () => {
      if (onAfterSetState) {
        onAfterSetState(data);
      }
      if (loadImage) {
        await this.loadImages(stateKey, imageStateKey);
      }
    });
  } catch (error) {
    console.error(`Error loading data for ${stateKey} from ${path}`, error);
  }
};

      
  loadImages = async (sourceStateKey, targetImageStateKey = "") => {
    const rows = this.state[sourceStateKey] || [];    

    const getImage = await Actions.loadImageBlobUrls({
      rows,
      fileField: "logo",
      idField: "id",
      baseUrl: ATTACH_FILE_CONTENT_URL
    });

    this.setState({ [targetImageStateKey]: getImage });
    
  };
  
//   loadStaticData = async () => {
//     return [
//       {
//         id: 1,
//         image: '/images/img_racehose_2.png',
//         date: '20 เมษายน 2568',
//         name: 'EEC เปิดอบรมเชิงปฏิบัติการ “การพัฒนาซอฟต์แวร์บอต” เสริมศักยภาพบุคลากร',
//         detail: 'สำนักงานเขตพัฒนาพิเศษภาคตะวันออก (EEC) จัดกิจกรรมสัมมนาเชิงปฏิบัติการเพื่อเสริมสร้างศักยภาพการพัฒนาซอฟต์แวร์อัตโนมัติ แก่เยาวชนในพื้นที่ภาคตะวันออก',
//       },
//       {
//         id: 2,
//         image: '/images/img_racehose_2_130x231.png',
//         date: '20 เมษายน 2568',
//         name: 'EEC เปิดอบรมเชิงปฏิบัติการ “การพัฒนาซอฟต์แวร์บอตสำหรับระบบอัตโนมัติ”',
//         detail: 'เหมาะสำหรับ: นักพัฒนาซอฟต์แวร์, นักศึกษา, บุคลากรภาคอุตสาหกรรม ที่ต้องการเสริมทักษะด้าน Automation',
//       },
//       {
//         id: 3,
//         image: '/images/img_racehose_2_1.png',
//         date: '20 เมษายน 2568',
//         name: 'EEC เปิดอบรมเชิงปฏิบัติการ “การพัฒนาเทคโนโลยีปัญญาประดิษฐ์ (AI) สำหรับอุตสาหกรรม”',
//         detail: 'เหมาะสำหรับ: บุคลากรภาคอุตสาหกรรม, นักเรียน, นักศึกษา และการเรียนรู้เชิงปฏิบัติของภาคเอกชน',
//       },
//     ];
//   };
// tileClassName = ({ date, view }) => {
  //   if (view === 'month') {
  //     const matched = this.state.DataTable1.some(item => {
  //       const pubDate = moment(item.publicize_date).format('YYYY-MM-DD');
  //       return moment(date).format('YYYY-MM-DD') === pubDate;
  //     });
  //     return matched ? 'highlight-date' : null;
  //   }
  // }

renderNewsDescription = (groupName) => {
  // const prefix = "ประชาสัมพันธ์";

  switch (groupName) {
    case'ข่าวสารทั่วไป':
      return 'ศูนย์กลางข้อมูลข่าวสาร ความก้าวหน้า และโอกาสการพัฒนาทั้งในด้านการลงทุน นวัตกรรม และเศรษฐกิจในเขตพัฒนาพิเศษภาคตะวันออก';

    case'กิจกรรม':
      return 'ติดตามกิจกรรมและความเคลื่อนไหวจากหน่วยงานต่าง ๆ ที่เกี่ยวข้องกับการพัฒนาในพื้นที่ EEC';

    case'สถาบัน':
      return 'ข้อมูลเกี่ยวกับสถาบันการศึกษา หน่วยงานฝึกอบรม และองค์กรที่เกี่ยวข้องกับการส่งเสริมกำลังคนในพื้นที่ EEC';

    case'หลักสูตร':
      return 'หลักสูตรที่ได้รับการพัฒนาเพื่อเตรียมความพร้อมด้านทักษะ และการเรียนรู้ให้สอดคล้องกับอุตสาหกรรมเป้าหมาย';

    case'ฝึกอบรม':
      return 'โอกาสในการเข้าร่วมการฝึกอบรมเพื่อยกระดับศักยภาพแรงงานและผู้ประกอบการในเขตพัฒนาพิเศษภาคตะวันออก';

    case'ตำแหน่งงาน':
      return 'รวมตำแหน่งงานจากหน่วยงานภาครัฐและเอกชนในพื้นที่ EEC ที่เปิดรับสมัคร พร้อมโอกาสด้านอาชีพหลากหลาย';

    default:
      return 'ศูนย์กลางข้อมูลข่าวสาร โอกาสการลงทุน และกิจกรรมที่ส่งเสริมการพัฒนาอย่างยั่งยืนในภาคตะวันออกของประเทศไทย';
  }
};

getNetworkItemsPerView = () => (this.state.isMobile ? 1 : 3);

getNetworkTotalPages = () => {
    const perView = this.getNetworkItemsPerView();
    return Math.max(1, Math.ceil((this.state.DataTable5?.length || 0) / perView));
};

handlePrevNetwork = () => {
    this.setState((prev) => ({
        networkIndex: Math.max(prev.networkIndex - 1, 0),
    }));
};

handleNextNetwork = () => {
    const totalPages = this.getNetworkTotalPages();
    this.setState((prev) => ({
        networkIndex: Math.min(prev.networkIndex + 1, totalPages - 1),
    }));
};

    
  render() {
    const { DataTable1, DataTable3, DataTable4, DataTable5, bannerIndex } = this.state;

    const currentHero = heroImages[bannerIndex];

    const OverAllPoster = () => (
        <Row className='mb-5'>
            <img
              src={overallPoster}
              alt=""
              className="rounded shadow-sm mb-5"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />

            <p className="text-white fs-5">
              การพัฒนากำลังคนมีความแม่นตรงตามความต้องการของภาคอุตสาหกรรม หยุดความสูญเปล่าทางการศึกษาลดระยะเวลาในการผลิตบุคลากรตามความต้องการของอุตสาหกรรมให้มีทักษะสูงตรงตามต้องการ เป็นแนวการพัฒนากำลังคนที่ สกพอ. เร่งผลักดัน เป็นรูปแบบการผลิตบุคลากรว่วมกันระหว่างสถานประกอบการกับสถานศึกษาในพื้นที่เขตพัฒนาพิเศษภาคตะวันออก และขณะเดียวกันก็เร่งให้การศึกษาต้องปรับตัวให้เท่าทันเทคโนโลยีของภาคอุตสาหกรรมที่เรียกว่า EEC Model ผลิตและพัฒนาบุคลากรทั้งในระบบการศึกษาและบุคลากรในภาคการจ้างงานเพื่อพัฒนาระดับเทคโนโลยีในการผลิตและ การบริการ ทั้งนี้ EEC Model ที่สกพอ.ขับเคลื่อนตามหลักการดังกล่าวมี 3 รูปแบบ คือ
            </p>

            <ul className="text-white ps-3 fs-5" >
              <li className='my-2'>
                <strong style={{ color: '#f99e39' }}>EEC Model Type A</strong> เพื่อให้การพัฒนากำลังคนครอบครอบคลุมทั้งจากระบบการศึกษาที่ทำหน้าที่ผลิตบุคลากรป้อนเข้าสู่ภาคอุตสาหกรรม
              </li>
              <li className='my-2'>
                <strong style={{ color: '#f99e39' }}>EEC Model Type B</strong> การพัฒนากำลังคนที่อยู่ในระบบการจ้างงานเดิมเพื่อรองรับการพัฒนาเทศโนโลยีการผลิตและการขยายการลงทุนของภาคอุตสาหกรรม สร้างความเข้มแข็งให้กับโซ่อุปทานของทั้ง 12 อุตสาหกรรมเป้าหมาย
              </li>
              <li className='my-2'>
                <strong style={{ color: '#f99e39' }}>EEC Model Type C</strong> เพื่อให้เกิดการพัฒนากำลังคนครอบครอมทุกส่วน สามารถตอบสนองการพัฒนาการลงทุนในพื้นที่ได้อย่างยังยืนและสร้างความเข้มแข็งให้กับภาคอุตสาหกรรม รองรับการขยายตัวของการลงทุนที่จะเกิดขึ้นในพื้นที่ EEC
              </li>
            </ul>
        </Row>
    )
    
    return (
      <div className={styles.pageContainer} style={{ 
        // backgroundImage: "url('/images/img__3.png')",
        backgroundColor: '#002A66',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover'
      }}>
        <Header />

       <div id="heroBannerContainer" className="position-relative w-100 overflow-hidden" style={{ height: '792px' }}>
        {/* Map All Slides */}
        {heroImages.map((hero, idx) => (
          <div
            key={idx}
            className="w-100 h-100 position-absolute top-0 start-0 transition-fade"
            style={{
              opacity: idx === bannerIndex ? 1 : 0,
              transition: 'opacity 1s ease-in-out',
              zIndex: idx === bannerIndex ? 1 : 0,
            }}
          >
            <img
              src={hero.src}
              alt={hero.alt}
              className="w-100 h-100 object-fit-cover"
              style={{ objectFit: 'cover' }}
            />
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
            ></div>
          </div>
        ))}

        {/* Slide Content (above all slides) */}
        <div
          className="position-relative d-flex flex-row align-items-center justify-content-between h-100 px-5"
          style={{ zIndex: 10 }}
        >
          {!this.state.isMobile && (<img
            src="/images/img_arrowleft.svg"
            alt="Previous"
            className="cursor-pointer"
            width={32}
            height={32}
            onClick={this.handlePrevBanner}
          />)}

          <div className="d-flex flex-column text-center" style={{ maxWidth: '950px' }}>
            <h1 className="display-3 fw-medium text-white mb-3">
              {currentHero.title.split('\n').map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h1>
            <p className="text-white fs-5 text-bold" style={{ paddingInline: 80 }}>
              {currentHero.subtitle.split('\n').map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          </div>

          {!this.state.isMobile && (<img
            src="/images/img_arrowright.svg"
            alt="Next"
            className="cursor-pointer"
            width={32}
            height={32}
            onClick={this.handleNextBanner}
          />)}
        </div>

        {/* Slide Indicators */}
        <div
          className="position-absolute bottom-0 start-50 translate-middle-x d-flex align-items-center gap-3 mb-4"
          style={{ zIndex: 10 }}
        >
          {heroImages.map((_, idx) => (
            <div
              key={idx}
              onClick={() => this.setState({ bannerIndex: idx })}
              className={`bg-white rounded-circle cursor-pointer ${idx === bannerIndex ? '' : 'bg-opacity-50'}`}
              style={{ width: '10px', height: '10px', transition: 'all 0.5s ease-in-out', }}
            ></div>
          ))}
        </div>
      </div>
      {/* 
      {this.state.newsGroups.length > 0 && (<Container id="newsSectionContainer" className="mt-4">
          <Container fluid className="news-section px-4 py-5 position-relative">   
            <Row className="mb-4">
              <Col>
              {this.state.newsGroups.length > 0 && (
                <>
                  <h2 className="news-title mb-3">{`ประชาสัมพันธ์`+this.state.newsGroups[this.state.activeGroupIndex].groupName || 'ประชาสัมพันธ์'}</h2>
                  <p className="news-description">
                    {this.renderNewsDescription(this.state.newsGroups[this.state.activeGroupIndex].groupName)}
                  </p>
                </>
              )}
              </Col>
            </Row>
        <Row className="gx-4">
        {/* ซ้าย: list ข่าว }
        {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 1 && (
        <Col lg={6}>
          <Card className="news-list-box p-4 shadow-sm border-0 d-flex flex-column justify-content-between" style={{ minHeight: '540px' }}>
            <div>
              {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.slice(1).map((item) => (
                <Row key={item.id} className="mb-4 gx-3 align-items-start" onClick={() => this.props.navigate(`/publicize/news/${item?.source_type}/${item?.id}`)}>
                  <Col xs={5}>
                    <CommonImageFrontend
                      src={this.state.DatatableImage1?.[item.id] || null}
                      alt="ประชาสัมพันธ์"
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'cover',
                        borderRadius: '6px'
                      }}
                    />
                  </Col>
                  <Col xs={7}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span className="text-muted small">
                        {item.publicize_date && util.convertDateToTextBE(item.publicize_date)}
                      </span>
                      <div className="vr" style={{ height: '12px' }}></div>
                      <span className="text-muted small">ล่าสุด</span>
                    </div>
                    <h5 className="news-item-title mb-2">{item.name}</h5>
                    <p className="small text-body">{item.detail}</p>
                  </Col>
                </Row>
              ))}
            </div>
            
            <div className="mt-auto">
              <Button
                className="view-all-btn mt-4 d-flex align-items-center gap-1"
                onClick={() => this.props.navigate('/publicize')}
                style={{ minWidth: '140px', backgroundColor: '#0E3362', border: 'none', color: 'white' }}>
                <i className="fa-light fa-play me-2" />
                อ่านทั้งหมด
              </Button>
            </div>
          </Card>
        </Col>
      )}
      {/* ขวา: ข่าวเด่น }
        <Col
          lg={
            this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 1
              ? 6
              : 12
          }
        >
        {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 0 && (
          <Card
            className="featured-box text-white border-0 overflow-hidden position-relative p-0"
            onClick={() => {
              const item =
                this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0];
              if (item?.id && item?.source_type) {
                this.props.navigate(`/publicize/news/${item.source_type}/${item.id}/test`);
              }
            }}
          >
            <div
              style={{
                backgroundImage: `url(${
                  this.state.DatatableImage1?.[
                    this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                      ?.id
                  ] || '/images/default-image.jpg'
                })`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '540px',
                display: 'flex',
                alignItems: 'flex-end',
                filter: 'brightness(0.7)',
              }}
              className="rounded w-100"
            >
              <div className="featured-overlay p-4 w-100">
                <Button className="text-white btn-outline-light mb-3" size="sm">
                  ข่าวเด่น
                </Button>
                <p className="text-white mb-2">
                  {util.convertDateToTextBE(
                    this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                      ?.publicize_date
                  )}
                </p>
                <h3 className="featured-title text-white fw-bold">
                  {
                    this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                      ?.name
                  }
                </h3>
                <p className="text-white mt-2">
                  {util.truncateText(
                    this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                      ?.detail || '',
                    120
                  )}
                </p>
              </div>
            </div>
          </Card>
        )}
      </Col>
      </Row>
    */ }
    {/* ปุ่มเลื่อนซ้ายขวา */}
      {/* <button
        onClick={() =>
          this.setState({
            activeGroupIndex:
              (this.state.activeGroupIndex - 1 + this.state.newsGroups.length) %
              this.state.newsGroups.length,
          })
        }
        className="prevButton"
        style={{
          position: 'absolute',
          top: '50%',
          left: '-20px',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          src="/images/img_arrowleft.svg"
          alt="Previous"
          width={32}
          height={32}
        />
      </button>

      <button
        onClick={() =>
          this.setState({
            activeGroupIndex:
              (this.state.activeGroupIndex + 1) % this.state.newsGroups.length,
          })
        }
        className="nextButton"
        style={{
          position: 'absolute',
          top: '50%',
          right: '-20px',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          src="/images/img_arrowright.svg"
          alt="Next"
          width={32}
          height={32}
        />
      </button> */}

      {/* จุด Indicator สำหรับข่าว */}
    {/*
      {(<div
        className="position-absolute bottom-0 start-50 translate-middle-x d-flex align-items-center gap-3 mb-4"
        style={{ zIndex: 10 }}
      >
        {this.state.newsGroups.map((_, idx) => (
          <div
            key={idx}
            onClick={() => this.setState({ activeGroupIndex: idx })}
            className={`rounded-circle cursor-pointer ${
              idx === this.state.activeGroupIndex ? 'bg-dark' : 'bg-secondary bg-opacity-25'
            }`}
            style={{
              width: '10px',
              height: '10px',
              transition: 'all 0.5s ease-in-out',
            }}
          ></div>
        ))}
      </div>)}

      {!this.state.isMobile &&  (<button
        onClick={() =>
          this.setState({
            activeGroupIndex:
              (this.state.activeGroupIndex - 1 + this.state.newsGroups.length) %
              this.state.newsGroups.length,
          })
        }
        className="nav-circle-button prevButton"
        style={{ left: window.innerWidth <= 768 ? "16px" : "-30px" }}
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>)}
      
      {!this.state.isMobile && (<button
        onClick={() =>
          this.setState({
            activeGroupIndex:
              (this.state.activeGroupIndex + 1) % this.state.newsGroups.length,
          })
        }
        className="nav-circle-button nextButton"
        style={{ right: window.innerWidth <= 768 ? "16px" : "-30px" }}
      >
        <i className="fa-solid fa-chevron-right"></i>
      </button>)}
        </Container>
      </Container>)}
    */}

        {/* เนื้อหา */}
        <Container className="mt-4">
          <img
            src={demandClusters}
            alt=""
            className="rounded shadow-sm"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </Container>

        <Container className="mt-4">
          <Row>
            <span className='news-title'><strong style={{ color: '#f99e39' }}>EEC</strong> Model</span>
          </Row>
          <OverAllPoster/>
        </Container>

        {/** card สถิติ **/}
        <Container className="mt-4">
          <Container fluid className="news-section px-4 py-5">
            <Row className="mt-5 gx-4">
              {DataTable4?.map((stat) => (
                <Col lg={4} md={6} sm={12} className="mb-4" key={stat.id}>
                  <div
                    className="position-relative rounded overflow-hidden shadow-sm text-white text-start"
                    style={{
                      backgroundImage: `url('${stat.backgroundImage}')`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      height: '200px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>
                    <div className="position-relative p-4" style={{ zIndex: 2 }}>
                      <h5 className="fw-semibold mb-2 text-white">{stat.title}</h5>
                      <h3 className="display-5 fw-bold mb-0 text-white">{stat.value ? util.formatNumber(stat.value,true) : ''}</h3>
                      <p className="text-uppercase small mb-0 text-white">{stat.value ? stat.unit : 'ไม่พบข้อมูล'}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
        <Container>
            <Row className="justify-content-center p-4">
                <Col md={4} className="text-center">
                <iframe
                    width="100%"
                    height="215"
                    src={youtubeUrl1}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
                </Col>

                <Col md={4} className="text-center">
                <iframe
                    width="100%"
                    height="215"
                    src={youtubeUrl2}
                    title="YouTube video player"
                    allowFullScreen
                />
                </Col>

                <Col md={4} className="text-center">
                <iframe
                    width="100%"
                    height="215"
                    src={youtubeUrl3}
                    title="YouTube video player"
                    allowFullScreen
                />
                </Col>
            </Row>
        </Container>

        {/** ศูนย์เครือข่าย **/}
        <Container className="mt-4 mb-5">
            <Container fluid className="news-section px-4 py-5 position-relative">
                <Row className="mb-4">
                <Col>
                    <h2 className="news-title mb-3" style={{ color: '#ffffff' }}>ศูนย์เครือข่าย</h2>
                    <p className="news-description fs-5" style={{ color: '#ffffff' }}>
                    EEC Nets คือศูนย์เครือข่ายแห่งนวัตกรรมที่เชื่อมโยงการศึกษา เทคโนโลยี และอุตสาหกรรม เพื่อพัฒนาทักษะแรงงานยุคใหม่ให้ทันต่อการเปลี่ยนแปลงของโลกอนาคต
                    </p>
                </Col>
                </Row>

                {DataTable5?.length > 0 && (() => {
                const perView = this.getNetworkItemsPerView();
                const totalPages = this.getNetworkTotalPages();
                const start = this.state.networkIndex * perView;
                const visibleItems = DataTable5.slice(start, start + perView);

                return (
                    <>
                    <Row className="gx-4 gy-4">
                        {visibleItems.map((x, idx) => (
                          <Col lg={4} md={4} sm={12} key={x?.id || idx}>
                            <Card
                              className="shadow-sm h-100 border-0 p-3 d-flex flex-row align-items-center"
                              onClick={() => this.props.navigate('/publicize/eec/' + x?.id)}
                              style={{ cursor: 'pointer' }}
                            >
                              <CommonImageFrontend
                                src={this.state.DatatableImage5?.[x?.id] || null}
                                alt="ศูนย์เครือข่าย"
                                style={{ width: '120px', height: '120px', objectFit: 'cover', marginRight: '16px', flexShrink: 0 }}
                              />
                              <div className="flex-grow-1">
                                <span
                                  className="badge mb-2"
                                  style={{ backgroundColor: '#0E3362', color: '#fff', fontWeight: 400 }}
                                >
                                  ศูนย์เครือข่าย
                                </span>

                                <h5 className="fw-semibold mb-2" title={x?.name}>
                                  {util.truncateText(x?.name, 22)}
                                </h5>

                                <p className="small text-muted mb-2">
                                  {util.truncateText(x?.description, 100)}
                                </p>

                                {x?.location && (
                                  <p className="text-muted small mb-0 d-flex align-items-start gap-1">
                                    <i className="fa-light fa-location-dot mt-1"></i>
                                    <span>{util.truncateText(x?.location, 70)}</span>
                                  </p>
                                )}
                              </div>
                            </Card>
                          </Col>
                            /* col 1
                              <Col lg={6} md={6} sm={12} key={x?.id || idx}>
                              <Card
                                  className="border-0 shadow-sm overflow-hidden h-100"
                                  style={{ cursor: 'pointer', borderRadius: '12px' }}
                                  onClick={() => this.props.navigate('/publicize/eec/' + x?.id)}
                              >
                                  <div
                                  style={{
                                      backgroundImage: `url(${this.state.DatatableImage5?.[x?.id] || '/images/default-image.jpg'})`,
                                      backgroundSize: 'cover',
                                      backgroundPosition: 'center',
                                      height: 'clamp(160px, 28vw, 260px)',
                                      width: '100%',
                                  }}
                                  />

                                  <Card.Body className="p-3 p-md-4">
                                  <span
                                      className="badge mb-2"
                                      style={{ backgroundColor: '#0E3362', color: '#fff', fontWeight: 400 }}
                                  >
                                      ศูนย์เครือข่าย
                                  </span>

                                  <h5
                                      className="fw-bold mb-2"
                                      style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)' }}
                                  >
                                      {x?.name}
                                  </h5>

                                  <p
                                      className="text-body mb-2"
                                      style={{ fontSize: 'clamp(0.85rem, 1.5vw, 1rem)' }}
                                  >
                                      {util.truncateText(x?.description, 100)}
                                  </p>

                                  {x?.location && (
                                      <p className="text-muted small mb-0 d-flex align-items-start gap-1">
                                      <i className="fa-light fa-location-dot mt-1"></i>
                                      <span>{util.truncateText(x?.location, 70)}</span>
                                      </p>
                                  )}
                                  </Card.Body>
                              </Card>
                              </Col>
                            */
                           /* col 2                      
                              <Col md={6} key={item?.id}>
                                <Card className="shadow-sm h-100 border-0 p-3 d-flex flex-row align-items-start" onClick={() => this.props.navigate('news/'+item.source_type+'/'+item?.id)} style={{ cursor: 'pointer' }}> 
                                  <CommonImageFrontend
                                    src={imagesPosition?.[item?.id] || null}
                                    alt="ประชาสัมพันธ์"
                                    style={{ width: '120px', height: '120px', objectFit: 'cover', marginRight: '16px' }}
                                  />
                                  <div className="flex-grow-1">
                                    <small className="text-muted d-block mb-1">
                                      {util.convertDateToTextBE(item?.publicize_date)}
                                    </small>
                                    <h5 className="fw-semibold mb-2">{`ตำแหน่ง: `+item?.position_name}</h5>
                                    <p className=" text-muted mb-0">{`จำนวน: `+item?.people_count+` อัตรา`}</p>
                                    <p className=" text-muted mb-0">{`หน่วยงาน/บริษัท: `+item?.operator_name}</p>
                                  </div>
                                </Card>
                              </Col>
                            */
                        ))}
                        </Row>

                        {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-4">
                            <Button
                                onClick={this.handlePrevNetwork}
                                variant="outline-primary"
                                disabled={this.state.networkIndex <= 0}
                            >
                                &laquo; ก่อนหน้า
                            </Button>
                            <span style={{ color: '#ffffff' }}>
                                หน้า {this.state.networkIndex + 1} จาก {totalPages}
                            </span>
                            <Button
                                onClick={this.handleNextNetwork}
                                variant="outline-primary"
                                disabled={this.state.networkIndex >= totalPages - 1}
                            >
                                ถัดไป &raquo;
                            </Button>
                        </div>
                        )}
                    </>
                );
                })()}
            </Container>
        </Container>
          
        {/* cookie privacy policy
            <Container className="my-5">
            <Row className="gx-4 gy-4 mt-10">
                <div className="d-flex flex-row bg-light border rounded shadow-sm p-4 align-items-start">
                <div className="me-4">
                    <div className="d-flex align-items-center justify-content-center bg-white border rounded-circle" style={{ width: '88px', height: '88px' }}>
                    <img src="/images/img_cookie12197716_1.svg" alt="Cookie" style={{ width: '60px', height: '60px' }} />
                    </div>
                </div>

                <div className="flex-grow-1">
                    <h4 className="fw-bold mb-3">ยอมรับคุกกี้ และนโยบายความเป็นส่วนตัว</h4>
                    <p className="mb-0">
                    เว็บไซต์นี้มีการใช้งานคุกกี้เพื่อให้ท่านสามารถใช้บริการได้อย่างต่อเนื่องและอำนวยความสะดวกในการใช้งานเว็บไซต์ <br />
                    รวมถึงช่วยให้เราปรับปรุงการนำเสนอเนื้อหาตรงตามความต้องการของท่าน โดยสามารถศึกษารายละเอียดเพิ่มเติมใน{' '}
                    <span className="text-primary text-decoration-underline" style={{ cursor: 'pointer' }}>นโยบายความเป็นส่วนตัว</span>
                    </p>
                </div>

                <div className="d-flex flex-column ms-4" style={{ width: '200px' }}>
                    <Button  className="mb-2 bg-dark text-white d-flex align-items-center justify-content-center gap-2">
                    
                    <img src="/images/img_tickcircle.svg" alt="Accept" width={20} height={20} />
                    ยอมรับเงื่อนไข
                    </Button>
                    <Button  variant="outline-dark" className="mb-2 d-flex align-items-center justify-content-center gap-2">
                    
                    <img src="/images/img_setting3.svg" alt="Settings" width={20} height={20} />
                    การตั้งค่าคุกกี้
                    </Button>
                    <Button  variant="outline-secondary">
                    
                    ปิด
                    </Button>
                </div>
                </div>
            </Row>
            </Container>
        end cookie privacy policy  */}

        <Footer />
      </div>
    );
  }
}

export default withRouter(HomePage);
